/* ==========================================================================
   BJAMIL Ring Builder - Custom App
   3-step ring builder: Setting → Diamond → Complete
   ========================================================================== */

(function () {
  'use strict';

  /* ---- Constants ---- */
  var SHAPES = ['Round','Oval','Emerald','Pear','Princess','Cushion','Radiant','Marquise','Heart','Asscher'];
  var CARATS = ['0.5','1','1.5','2','2.5','3','3.5','4'];
  var COLORS = ['D','E','F'];
  var CLARITIES = ['SI','VS','VVS','FL'];

  var METAL_COLORS = {
    '9k white gold':'#B0B7BC','10k white gold':'#B0B7BC','14k white gold':'#B0B7BC','18k white gold':'#B0B7BC',
    '9k yellow gold':'#D4A017','10k yellow gold':'#D4A017','14k yellow gold':'#D4A017','18k yellow gold':'#D4A017',
    '9k rose gold':'#C07080','10k rose gold':'#C07080','14k rose gold':'#C07080','18k rose gold':'#C07080',
    '950 platinum':'#A8A9AD'
  };

  // Explicit metal display order: 3x3 grid + platinum
  var METAL_ORDER = [
    '10K White Gold','10K Yellow Gold','10K Rose Gold',
    '14K White Gold','14K Yellow Gold','14K Rose Gold',
    '18K White Gold','18K Yellow Gold','18K Rose Gold',
    '950 Platinum'
  ];

  var SHAPE_SVGS = {
    Round:'<svg viewBox="0 0 40 40"><circle cx="20" cy="20" r="15" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="20" cy="20" r="8" fill="none" stroke="currentColor" stroke-width="0.8" opacity="0.5"/></svg>',
    Oval:'<svg viewBox="0 0 40 40"><ellipse cx="20" cy="20" rx="11" ry="16" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    Emerald:'<svg viewBox="0 0 40 40"><rect x="9" y="6" width="22" height="28" rx="3" fill="none" stroke="currentColor" stroke-width="1.5"/><rect x="13" y="10" width="14" height="20" rx="1" fill="none" stroke="currentColor" stroke-width="0.8" opacity="0.5"/></svg>',
    Pear:'<svg viewBox="0 0 40 40"><path d="M20 5C13 14 9 22 9 27c0 5 5 9 11 9s11-4 11-9c0-5-4-13-11-22z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    Princess:'<svg viewBox="0 0 40 40"><rect x="8" y="8" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5"/><line x1="8" y1="8" x2="32" y2="32" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="32" y1="8" x2="8" y2="32" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>',
    Cushion:'<svg viewBox="0 0 40 40"><rect x="7" y="7" width="26" height="26" rx="7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    Radiant:'<svg viewBox="0 0 40 40"><rect x="9" y="6" width="22" height="28" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><line x1="9" y1="6" x2="31" y2="34" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="31" y1="6" x2="9" y2="34" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>',
    Marquise:'<svg viewBox="0 0 40 40"><ellipse cx="20" cy="20" rx="9" ry="17" fill="none" stroke="currentColor" stroke-width="1.5"/><line x1="11" y1="20" x2="29" y2="20" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>',
    Heart:'<svg viewBox="0 0 40 40"><path d="M20 35l-1.5-1.3C10 26 5 21.5 5 16c0-4.4 3.6-8 8-8 2.5 0 5 1.2 7 3.2C22 9.2 24.5 8 27 8c4.4 0 8 3.6 8 8 0 5.5-5 10-13.5 17.7z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    Asscher:'<svg viewBox="0 0 40 40"><polygon points="13,4 27,4 36,13 36,27 27,36 13,36 4,27 4,13" fill="none" stroke="currentColor" stroke-width="1.5"/><polygon points="16,9 24,9 30,16 30,24 24,31 16,31 10,24 10,16" fill="none" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>'
  };

  var STYLES = ['Solitaire','Three Stone','Side Stone','Diamond Band','Nature','Vintage'];

  var STYLE_SVGS = {
    'Solitaire':'<svg viewBox="0 0 60 60"><circle cx="30" cy="18" r="8" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M22 26c-4 2-8 6-8 10v4h32v-4c0-4-4-8-8-10" fill="none" stroke="currentColor" stroke-width="1.5"/><line x1="30" y1="40" x2="30" y2="52" stroke="currentColor" stroke-width="1.5"/></svg>',
    'Three Stone':'<svg viewBox="0 0 60 60"><circle cx="30" cy="20" r="7" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="14" cy="26" r="5" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="46" cy="26" r="5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8 36h44" stroke="currentColor" stroke-width="1.5"/></svg>',
    'Halo':'<svg viewBox="0 0 60 60"><circle cx="30" cy="22" r="7" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="30" cy="22" r="12" fill="none" stroke="currentColor" stroke-width="1" stroke-dasharray="2,2"/><path d="M18 30c-4 2-6 5-6 8h36c0-3-2-6-6-8" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    'Hidden Halo':'<svg viewBox="0 0 60 60"><circle cx="30" cy="20" r="8" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M22 25c0 3 3 5 8 5s8-2 8-5" fill="none" stroke="currentColor" stroke-width="1" stroke-dasharray="2,2"/><path d="M20 32c-4 2-6 5-6 8h32c0-3-2-6-6-8" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    'Side Stone':'<svg viewBox="0 0 60 60"><circle cx="30" cy="20" r="7" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="18" cy="30" r="3" fill="none" stroke="currentColor" stroke-width="1.2"/><circle cx="42" cy="30" r="3" fill="none" stroke="currentColor" stroke-width="1.2"/><path d="M10 38h40" stroke="currentColor" stroke-width="1.5"/></svg>',
    'Diamond Band':'<svg viewBox="0 0 60 60"><ellipse cx="30" cy="30" rx="18" ry="12" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="18" cy="26" r="2" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="24" cy="22" r="2" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="30" cy="20" r="2.5" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="36" cy="22" r="2" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="42" cy="26" r="2" fill="none" stroke="currentColor" stroke-width="1"/></svg>',
    'Nature':'<svg viewBox="0 0 60 60"><circle cx="30" cy="18" r="6" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M24 24c-6 2-10 6-10 10M36 24c6 2 10 6 10 10" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M20 30c2 0 3-2 3-4M40 30c-2 0-3-2-3-4" fill="none" stroke="currentColor" stroke-width="1" opacity="0.6"/></svg>',
    'Vintage':'<svg viewBox="0 0 60 60"><circle cx="30" cy="20" r="7" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M23 27l-8 8M37 27l8 8" fill="none" stroke="currentColor" stroke-width="1.2"/><circle cx="30" cy="20" r="11" fill="none" stroke="currentColor" stroke-width="0.8" stroke-dasharray="3,2"/><path d="M14 40h32" stroke="currentColor" stroke-width="1.5"/></svg>'
  };

  // Derive style from product title
  function detectStyle(title) {
    var t = title.toLowerCase();
    if (t.indexOf('three') > -1 || t.indexOf('trilogy') > -1 || t.indexOf('five stone') > -1) return 'Three Stone';
    if (t.indexOf('halo') > -1 && t.indexOf('hidden') === -1) return 'Halo';
    if (t.indexOf('hidden halo') > -1) return 'Hidden Halo';
    if (t.indexOf('wave') > -1 || t.indexOf('twist') > -1 || t.indexOf('floral') > -1 || t.indexOf('cascade') > -1) return 'Nature';
    if (t.indexOf('cluster') > -1 || t.indexOf('celestial') > -1 || t.indexOf('tiered') > -1) return 'Vintage';
    if (t.indexOf('band') > -1 || t.indexOf('eternity') > -1 || t.indexOf('channel') > -1) return 'Diamond Band';
    if (t.indexOf('shoulder') > -1 || t.indexOf('accent') > -1 || t.indexOf('baguette') > -1 || t.indexOf('graduated') > -1 || t.indexOf('side') > -1) return 'Side Stone';
    if (t.indexOf('solitaire') > -1 || t.indexOf('bezel') > -1 || t.indexOf('split') > -1) return 'Solitaire';
    return 'Solitaire';
  }

  // Parse metal into karat badge + base color
  function metalParts(metal) {
    var m = metal || '';
    var match = m.match(/^(\d+K?|950)\s*(.*)/i);
    if (match) {
      return { karat: match[1].toUpperCase(), base: match[2].trim() };
    }
    return { karat: '', base: m };
  }

  /* ---- Cloudinary CDN Video/Image helpers ---- */
  var CLOUDINARY_CDN = 'https://res.cloudinary.com/dpaim87o8/video/upload/f_mp4,vc_h264,q_auto/bjamil-rings/';
  var NIVODA_CDN = 'https://s3.eu-west-2.amazonaws.com/loupe360.jewelry/';

  var SHAPE_CODES = {
    'Round':'RD','Princess':'PR','Cushion':'CU','Oval':'OV','Pear':'PE',
    'Emerald':'EM','Heart':'HRT','Radiant':'RAD','Asscher':'AS','Marquise':'MQ'
  };

  var METAL_CDN_NAMES = {
    'white gold':'WHITE','yellow gold':'YELLOW','rose gold':'ROSE','platinum':'PLATINUM'
  };

  // Extract Nivoda model ID from product image filenames (e.g. NVDRG00009)
  function nivodaModel(product) {
    if (!product || !product.images || !product.images.length) return null;
    for (var i = 0; i < product.images.length; i++) {
      var filename = product.images[i].src.split('/').pop().split('?')[0];
      var match = filename.match(/^(NVDRG\d+)/);
      if (match) return match[1];
    }
    return null;
  }

  // Get CDN metal name from metal string like "14K White Gold"
  function cdnMetal(metal) {
    if (!metal) return 'WHITE';
    var lower = metal.toLowerCase();
    for (var key in METAL_CDN_NAMES) {
      if (lower.indexOf(key) > -1) return METAL_CDN_NAMES[key];
    }
    return 'WHITE';
  }

  var DIAMOND_VIDEO_CDN = 'https://res.cloudinary.com/dpaim87o8/video/upload/f_mp4,vc_h264,q_auto/bjamil-diamonds/';

  // Build video URL from Cloudinary for settings
  function nivodaVideoUrl(model, shape, metal) {
    var sc = SHAPE_CODES[shape] || 'RD';
    var mc = cdnMetal(metal);
    return CLOUDINARY_CDN + model + '-' + sc + '_' + mc + '.mp4';
  }

  // Build diamond video URL from Cloudinary
  function diamondVideoUrl(shape) {
    return DIAMOND_VIDEO_CDN + (shape || 'Round') + '.mp4';
  }

  // Build image URLs from Nivoda CDN (still used for SIDE, FRONT, 3D stills)
  function nivodaImageUrls(model, shape, metal) {
    var sc = SHAPE_CODES[shape] || 'RD';
    var mc = cdnMetal(metal);
    var base = NIVODA_CDN + model + '-' + sc + '/' + model + '-' + sc + '_Renders/' + model + '-' + sc + '_' + mc;
    return {
      side: base + '_SIDE.jpg',
      front: base + '_FRONT.jpg',
      threeD: base + '_3D.jpg'
    };
  }

  var CURRENCY = 'CAD';

  // Diamond size chart (mm) — industry standard ideal cut proportions
  // Symmetric shapes: single value = diameter/side. Elongated: [length, width]
  var DIAMOND_MM = {
    'Round':    {0.5:5.0, 1:6.5, 1.5:7.4, 2:8.2, 2.5:8.8, 3:9.3, 3.5:9.75, 4:10.2},
    'Oval':     {0.5:[6,4], 1:[7.7,5.7], 1.5:[8.5,6.5], 2:[9,7], 2.5:[9.8,7.5], 3:[10.5,8], 3.5:[11,8.5], 4:[11.5,8.7]},
    'Princess': {0.5:4.5, 1:5.5, 1.5:6.2, 2:7.0, 2.5:7.5, 3:8.0, 3.5:8.35, 4:8.7},
    'Emerald':  {0.5:[5.5,4], 1:[7,5], 1.5:[7.5,5.5], 2:[8.5,6.5], 2.5:[9,7], 3:[10,7.5], 3.5:[10.5,7.75], 4:[11,8]},
    'Cushion':  {0.5:4.5, 1:5.5, 1.5:6.5, 2:7.0, 2.5:7.5, 3:8.0, 3.5:8.5, 4:8.9},
    'Pear':     {0.5:[6.5,4.5], 1:[8,5.5], 1.5:[9,6], 2:[10,6.7], 2.5:[10.5,7], 3:[11.4,7.5], 3.5:[12,7.8], 4:[12.5,8]},
    'Radiant':  {0.5:[5,4.5], 1:[6.5,5.5], 1.5:[7,6], 2:[7.5,6.5], 2.5:[8,7], 3:[8.5,7.5], 3.5:[9,7.75], 4:[9.5,8]},
    'Marquise': {0.5:[8,4], 1:[10,5], 1.5:[11.5,5.75], 2:[13,6.5], 2.5:[14,7], 3:[15,7.5], 3.5:[15.5,7.75], 4:[16,8]},
    'Heart':    {0.5:5.0, 1:6.5, 1.5:7.5, 2:8.0, 2.5:8.5, 3:9.0, 3.5:9.4, 4:9.8},
    'Asscher':  {0.5:4.5, 1:5.5, 1.5:6.2, 2:7.0, 2.5:7.5, 3:8.0, 3.5:8.35, 4:8.7}
  };

  // Average female ring finger width ≈ 16mm. Hand image is calibrated so
  // the ring-finger area is ~8.5% of container width (containerPx × 0.085 ≈ fingerPx).
  // So 1mm = fingerPx / 16. Scale factor is relative to container.
  var HAND_IMG = 'https://cdn.shopify.com/s/files/1/0533/9129/4664/t/32/assets/hand-model.png';
  // Diamond position — measured from source PNG pixel analysis (1024x1024).
  // Ring finger center = 375px/1024 = 36.6% from left (consistent Y=35-47%).
  // Ring zone (between knuckle and joint) at Y=46% = 471px/1024.
  // Ring finger width at that zone = 99px/1024 = 9.7%.
  var DIAMOND_POS = { top: 46, left: 36.6 }; // percent of IMAGE dimensions
  var FINGER_WIDTH_PCT = 9.7; // ring-finger width as % of image width

  function getDiamondSizePx(shape, carat, containerWidth) {
    var table = DIAMOND_MM[shape] || DIAMOND_MM['Round'];
    // Find closest carat entries for interpolation
    var carats = Object.keys(table).map(Number).sort(function(a,b){return a-b;});
    var ct = Math.max(carats[0], Math.min(carats[carats.length-1], carat));
    var lower = carats[0], upper = carats[0];
    for (var i = 0; i < carats.length; i++) {
      if (carats[i] <= ct) lower = carats[i];
      if (carats[i] >= ct) { upper = carats[i]; break; }
    }
    var lVal = table[lower], uVal = table[upper];
    var t = lower === upper ? 0 : (ct - lower) / (upper - lower);
    // Interpolate mm dimensions
    var wMM, hMM;
    if (Array.isArray(lVal)) {
      wMM = lVal[1] + t * ((Array.isArray(uVal) ? uVal[1] : uVal) - lVal[1]); // width
      hMM = lVal[0] + t * ((Array.isArray(uVal) ? uVal[0] : uVal) - lVal[0]); // height/length
    } else {
      wMM = lVal + t * ((Array.isArray(uVal) ? uVal[0] : uVal) - lVal);
      hMM = wMM;
    }
    // Convert mm to px: ring finger = FINGER_WIDTH_PCT% of container = 16mm
    var pxPerMM = (containerWidth * FINGER_WIDTH_PCT / 100) / 16;
    return { w: Math.round(wMM * pxPerMM), h: Math.round(hMM * pxPerMM) };
  }

  // Diamond fill/stroke styling — realistic translucent diamond look
  var DF = 'rgba(220,230,245,0.55)'; // fill - icy translucent
  var DS = 'rgba(180,200,230,0.9)';  // stroke - subtle blue-silver edge
  var DW = '1.5'; // stroke width

  // SVG diamond shape outlines (viewBox uses natural aspect ratio per shape)
  var DIAMOND_SHAPE_SVGS = {
    'Round':    '<svg viewBox="0 0 100 100"><ellipse cx="50" cy="50" rx="46" ry="46" fill="'+DF+'" stroke="'+DS+'" stroke-width="'+DW+'"/><ellipse cx="50" cy="50" rx="30" ry="30" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="0.5"/></svg>',
    'Oval':     '<svg viewBox="0 0 70 100"><ellipse cx="35" cy="50" rx="32" ry="47" fill="'+DF+'" stroke="'+DS+'" stroke-width="'+DW+'"/></svg>',
    'Princess': '<svg viewBox="0 0 100 100"><rect x="4" y="4" width="92" height="92" fill="'+DF+'" stroke="'+DS+'" stroke-width="'+DW+'"/><line x1="4" y1="4" x2="96" y2="96" stroke="rgba(255,255,255,0.2)" stroke-width="0.5"/><line x1="96" y1="4" x2="4" y2="96" stroke="rgba(255,255,255,0.2)" stroke-width="0.5"/></svg>',
    'Emerald':  '<svg viewBox="0 0 65 100"><rect x="3" y="3" width="59" height="94" rx="8" fill="'+DF+'" stroke="'+DS+'" stroke-width="'+DW+'"/><rect x="12" y="12" width="41" height="76" rx="3" fill="none" stroke="rgba(255,255,255,0.25)" stroke-width="0.5"/></svg>',
    'Cushion':  '<svg viewBox="0 0 100 100"><rect x="4" y="4" width="92" height="92" rx="22" fill="'+DF+'" stroke="'+DS+'" stroke-width="'+DW+'"/></svg>',
    'Pear':     '<svg viewBox="0 0 67 100"><path d="M33.5 3C38 3 55 25 60 50C63 65 58 85 45 94C40 97 37 98 33.5 98C30 98 27 97 22 94C9 85 4 65 7 50C12 25 29 3 33.5 3Z" fill="'+DF+'" stroke="'+DS+'" stroke-width="'+DW+'"/></svg>',
    'Radiant':  '<svg viewBox="0 0 85 100"><rect x="3" y="3" width="79" height="94" rx="5" fill="'+DF+'" stroke="'+DS+'" stroke-width="'+DW+'"/><rect x="10" y="10" width="65" height="80" rx="2" fill="none" stroke="rgba(255,255,255,0.2)" stroke-width="0.5"/></svg>',
    'Marquise': '<svg viewBox="0 0 50 100"><ellipse cx="25" cy="50" rx="22" ry="47" fill="'+DF+'" stroke="'+DS+'" stroke-width="'+DW+'"/></svg>',
    'Heart':    '<svg viewBox="0 0 100 100"><path d="M50 92C50 92 6 62 6 33C6 16 17 5 32 5C40 5 47 10 50 17C53 10 60 5 68 5C83 5 94 16 94 33C94 62 50 92 50 92Z" fill="'+DF+'" stroke="'+DS+'" stroke-width="'+DW+'"/></svg>',
    'Asscher':  '<svg viewBox="0 0 100 100"><rect x="4" y="4" width="92" height="92" rx="2" fill="'+DF+'" stroke="'+DS+'" stroke-width="'+DW+'"/><rect x="15" y="15" width="70" height="70" rx="1" fill="none" stroke="rgba(255,255,255,0.2)" stroke-width="0.5"/></svg>'
  };

  /* ---- Helpers ---- */
  function fmt(price) {
    var n = parseFloat(price);
    if (isNaN(n)) return '$0 ' + CURRENCY;
    return '$' + n.toLocaleString('en-CA', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' ' + CURRENCY;
  }

  function tag(tags, prefix) {
    if (!tags) return null;
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i];
      if (t.toLowerCase().indexOf(prefix.toLowerCase() + ':') === 0) {
        return t.substring(prefix.length + 1).trim();
      }
    }
    return null;
  }

  function imgSize(url, w) {
    if (!url) return '';
    if (url.indexOf('?') > -1) return url + '&width=' + w;
    return url + '?width=' + w;
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function metalColor(metal) {
    return METAL_COLORS[(metal || '').toLowerCase()] || '#ccc';
  }

  function uniqueMetalTypes(variants) {
    var seen = {};
    var out = [];
    variants.forEach(function (v) {
      var m = v.option1;
      if (m && !seen[m]) { seen[m] = true; out.push(m); }
    });
    return out;
  }

  /* ---- RingBuilder Class ---- */
  function RingBuilder(el) {
    this.el = el;
    this.settingsHandle = el.dataset.settingsCollection || 'engagement-rings';
    this.labDiamondsHandle = el.dataset.diamondsCollection || 'diamond';
    this.naturalDiamondsHandle = el.dataset.naturalDiamondsCollection || 'natural-diamond';
    this.step = 1;
    this.settings = [];
    this.diamonds = [];
    this.labDiamonds = [];
    this.naturalDiamonds = [];

    // Selections
    this.selectedSetting = null;    // product object
    this.selectedMetal = null;
    this.selectedShape = null;
    this.selectedVariant = null;    // variant object
    this.selectedDiamond = null;    // product object
    this.ringSize = '';

    // UI state
    this.settingDetail = null;      // product being viewed in detail
    this.diamondView = 'grid';
    this.filtersVisible = true;

    // Setting filters
    this.sfStyle = null;
    this.sfShape = null;
    this.sfMetal = null;
    this.sfSort = 'price-asc';
    this.sfShowAllStyles = false;
    this.sfShowAllMetals = false;
    this.sfShowAllShapes = true;

    // Diamond filters
    this.dfType = 'Lab Grown';
    this.dfShape = null;
    this.dfCaratMin = '0.5';
    this.dfCaratMax = '4';
    this.dfColor = null;
    this.dfClarity = null;
    this.dfSort = 'price-asc';

    this._eventsBound = false;
    this.init();
  }

  RingBuilder.prototype.init = function () {
    var self = this;
    this.el.innerHTML = '<div class="rb-loading"><div class="rb-loading-spinner"></div>Chargement du Studio Bagues...</div>';

    Promise.all([
      this.loadCollection(this.settingsHandle),
      this.loadCollection(this.labDiamondsHandle),
      this.loadCollection(this.naturalDiamondsHandle)
    ]).then(function (results) {
      self.settings = results[0];
      self.labDiamonds = results[1];
      self.naturalDiamonds = results[2];
      self.diamonds = self.expandDiamonds(self.labDiamonds.concat(self.naturalDiamonds));
      self.render();
    }).catch(function (err) {
      self.el.innerHTML = '<div class="rb-loading">Erreur de chargement. Veuillez rafra\u00eechir la page.</div>';
      console.error('RingBuilder load error:', err);
    });
  };

  // Expand variant-based diamond products into individual virtual entries
  // Products with Carat/Clarity/Color options get one entry per variant
  // Old single-variant products pass through unchanged
  RingBuilder.prototype.expandDiamonds = function (products) {
    var expanded = [];
    // Track which shape+type combos have variant-based products
    var variantShapes = {};
    products.forEach(function (p) {
      var optNames = (p.options || []).map(function (o) { return o.name; });
      if (optNames.indexOf('Carat') >= 0 && optNames.indexOf('Clarity') >= 0 && optNames.indexOf('Color') >= 0) {
        var s = tag(p.tags, 'shape') || '';
        var t = tag(p.tags, 'type') || '';
        variantShapes[s + '|' + t] = true;
      }
    });

    products.forEach(function (p) {
      var optNames = (p.options || []).map(function (o) { return o.name; });
      var isVariantBased = optNames.indexOf('Carat') >= 0 && optNames.indexOf('Clarity') >= 0 && optNames.indexOf('Color') >= 0;

      if (isVariantBased) {
        var shapeTag = tag(p.tags, 'shape') || '';
        var typeTag = tag(p.tags, 'type') || '';
        p.variants.forEach(function (v) {
          expanded.push({
            _variantBased: true,
            _sourceProduct: p,
            _variant: v,
            id: p.id,
            handle: p.handle,
            title: v.option1 + ' ' + shapeTag + ' ' + (typeTag === 'Natural' ? 'Naturel' : typeTag),
            tags: ['shape:' + shapeTag, 'type:' + typeTag, 'carat:' + v.option1.replace('ct',''), 'clarity:' + v.option2, 'color:' + v.option3],
            images: p.images,
            variants: [v],
            options: p.options
          });
        });
      } else {
        // Skip old individual products if variant-based version exists for same shape+type
        var s = tag(p.tags, 'shape') || '';
        var t = tag(p.tags, 'type') || '';
        if (!variantShapes[s + '|' + t]) {
          expanded.push(p);
        }
      }
    });
    return expanded;
  };

  RingBuilder.prototype.loadCollection = function (handle) {
    var products = [];
    function fetchPage(page) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.products && data.products.length) {
            products = products.concat(data.products);
            if (data.products.length === 250) return fetchPage(page + 1);
          }
          return products;
        });
    }
    return fetchPage(1);
  };

  /* ---- Main Render ---- */
  RingBuilder.prototype.render = function () {
    var html = '';
    html += this.renderStepBar();
    html += '<div class="rb-content">';
    if (this.step === 1) {
      html += this.settingDetail ? this.renderSettingDetail() : this.renderStep1();
    } else if (this.step === 2) {
      html += this.renderStep2();
    } else {
      html += this.renderStep3();
    }
    html += '</div>';
    this.el.innerHTML = html;
    if (!this._eventsBound) {
      this.bindEvents();
      this._eventsBound = true;
    }
    // Force autoplay on video after DOM insertion
    var vid = this.el.querySelector('.rb-summary-video');
    if (vid && vid.tagName === 'VIDEO') {
      vid.muted = true;
      vid.play().catch(function () {});
    }
    // Size the hand model diamond after DOM is ready
    if (this.step === 2) {
      var self = this;
      requestAnimationFrame(function () {
        var slider = self.el.querySelector('.rb-hand-slider-input');
        var carat = slider ? parseFloat(slider.value) : 2;
        self.updateHandDiamond(carat);
      });
    }
  };

  /* ---- Step Bar ---- */
  RingBuilder.prototype.renderStepBar = function () {
    var self = this;
    var steps = [
      { n: 1, sub: 'Choisir une', label: 'MONTURE', sel: this.selectedSetting, price: this.selectedVariant ? fmt(this.selectedVariant.price) : null, meta: this.selectedMetal && this.selectedShape ? this.selectedMetal + ' / ' + this.selectedShape : null, img: this.selectedSetting ? imgSize(this.selectedSetting.images[0] && this.selectedSetting.images[0].src, 80) : null },
      { n: 2, sub: 'Choisir un', label: 'DIAMANT', sel: this.selectedDiamond, price: this.selectedDiamond ? fmt(this.selectedDiamond.variants[0].price) : null, meta: this.selectedDiamond ? this.selectedDiamond.title : null, img: this.selectedDiamond ? imgSize(this.selectedDiamond.images[0] && this.selectedDiamond.images[0].src, 80) : null },
      { n: 3, sub: 'Compl\u00e9ter votre', label: 'BAGUE', sel: null, price: (this.selectedVariant && this.selectedDiamond) ? fmt(parseFloat(this.selectedVariant.price) + parseFloat(this.selectedDiamond.variants[0].price)) : null, meta: null, img: null }
    ];

    var h = '<div class="rb-step-bar">';
    steps.forEach(function (s) {
      var active = self.step === s.n ? ' is-active' : '';
      var done = (s.n < self.step || (s.n <= 2 && s.sel));
      h += '<div class="rb-step' + active + '" data-step="' + s.n + '">';

      // Number / image / check
      h += '<div class="rb-step-number">';
      if (done && s.img) {
        h += '<img src="' + esc(s.img) + '" alt="">';
      } else if (done) {
        h += '<span class="rb-step-check">&#10003;</span>';
      } else {
        h += s.n;
      }
      h += '</div>';

      // Info
      h += '<div class="rb-step-info">';
      if (done && s.sel) {
        h += '<div class="rb-step-selected">';
        h += '<div class="rb-step-selected-name">' + esc(s.sel.title) + '</div>';
        if (s.meta) h += '<div style="font-size:11px;color:#888;">' + esc(s.meta) + '</div>';
        h += '<div class="rb-step-selected-price">' + (s.price || '') + '</div>';
        h += '<span class="rb-step-remove" data-remove="' + s.n + '">Retirer</span>';
        h += '</div>';
      } else {
        h += '<div class="rb-step-label-sub">' + s.sub + '</div>';
        h += '<div class="rb-step-label">' + s.label + '</div>';
        if (s.n === 3 && s.price) {
          h += '<div class="rb-step-selected-price">' + s.price + '</div>';
        }
      }
      h += '</div></div>';
    });
    h += '</div>';
    return h;
  };

  /* ---- Step 1: Settings Grid ---- */
  RingBuilder.prototype.renderStep1 = function () {
    var self = this;
    var filtered = this.getFilteredSettings();

    // Count active filters
    var activeCount = 0;
    if (this.sfStyle) activeCount++;
    if (this.sfMetal) activeCount++;
    if (this.sfShape) activeCount++;

    var h = '';

    // Filters container
    h += '<div class="rb-filters">';
    h += '<button class="rb-filter-toggle" data-action="toggle-filters">';
    h += (this.filtersVisible ? '&#8963; Masquer' : '&#8964; Afficher') + ' tous les filtres (' + activeCount + ')</button>';

    if (this.filtersVisible) {
      h += '<div class="rb-filter-panel">';

      // ----- Left column: Style + Metal -----
      h += '<div class="rb-filter-col">';

      // Style filter
      h += '<div class="rb-filter-group">';
      h += '<div class="rb-filter-heading">Style de monture</div>';
      h += '<div class="rb-filter-tiles">';
      var visibleStyles = this.sfShowAllStyles ? STYLES : STYLES.slice(0, 4);
      visibleStyles.forEach(function (s) {
        var active = self.sfStyle === s ? ' is-active' : '';
        h += '<div class="rb-tile' + active + '" data-action="sf-style" data-val="' + esc(s) + '">';
        h += '<div class="rb-tile-icon">' + (STYLE_SVGS[s] || '') + '</div>';
        h += '<div class="rb-tile-label">' + esc(s) + '</div></div>';
      });
      h += '</div>';
      if (STYLES.length > 4) {
        h += '<button class="rb-filter-more" data-action="sf-toggle-styles">';
        h += (this.sfShowAllStyles ? '&#8963; Moins de' : '&#8964; Plus de') + ' styles</button>';
      }
      h += '</div>';

      // Metal filter — use explicit METAL_ORDER for 3x3 grid
      var availableMetals = {};
      this.settings.forEach(function (p) {
        uniqueMetalTypes(p.variants).forEach(function (m) {
          availableMetals[m] = true;
        });
      });
      // Filter METAL_ORDER to only show metals that exist in products
      var orderedMetals = METAL_ORDER.filter(function (m) { return availableMetals[m]; });

      h += '<div class="rb-filter-group">';
      h += '<div class="rb-filter-heading">M\u00e9tal</div>';
      h += '<div class="rb-filter-tiles rb-metal-grid">';
      var visibleMetals = this.sfShowAllMetals ? orderedMetals : orderedMetals.slice(0, 3);
      visibleMetals.forEach(function (m) {
        var active = self.sfMetal === m ? ' is-active' : '';
        var parts = metalParts(m);
        h += '<div class="rb-tile' + active + '" data-action="sf-metal" data-val="' + esc(m) + '">';
        h += '<div class="rb-tile-icon"><span class="rb-metal-swatch" style="background:' + metalColor(m) + '">';
        if (parts.karat) h += '<span class="rb-metal-karat">' + esc(parts.karat) + '</span>';
        h += '</span></div>';
        h += '<div class="rb-tile-label">' + esc(parts.base) + '</div></div>';
      });
      h += '</div>';
      if (orderedMetals.length > 3) {
        h += '<button class="rb-filter-more" data-action="sf-toggle-metals">';
        h += (this.sfShowAllMetals ? '&#8963; Moins de' : '&#8964; Plus de') + ' m\u00e9taux</button>';
      }
      h += '</div>';

      h += '</div>'; // filter-col left

      // ----- Right column: Shape -----
      h += '<div class="rb-filter-col">';

      h += '<div class="rb-filter-group">';
      h += '<div class="rb-filter-heading">Forme</div>';
      h += '<div class="rb-filter-tiles">';
      var visibleShapes = this.sfShowAllShapes ? SHAPES : SHAPES.slice(0, 4);
      visibleShapes.forEach(function (s) {
        var active = self.sfShape === s ? ' is-active' : '';
        h += '<div class="rb-tile' + active + '" data-action="sf-shape" data-val="' + s + '">';
        h += '<div class="rb-tile-icon">' + (SHAPE_SVGS[s] || '') + '</div>';
        h += '<div class="rb-tile-label">' + esc(s) + '</div></div>';
      });
      h += '</div>';
      if (SHAPES.length > 4) {
        h += '<button class="rb-filter-more" data-action="sf-toggle-shapes">';
        h += (this.sfShowAllShapes ? '&#8963; Moins de' : '&#8964; Plus de') + ' formes</button>';
      }
      h += '</div>';

      h += '</div>'; // filter-col right
      h += '</div>'; // filter-panel
    }
    h += '</div>'; // filters

    // Sort + results
    h += '<div class="rb-results-bar">';
    h += '<div class="rb-results-count">R\u00e9sultats - <strong>' + filtered.length + '</strong> Montures</div>';
    h += '<div class="rb-sort-wrap"><label>Trier :</label>';
    h += '<select data-action="sf-sort">';
    h += '<option value="price-asc"' + (this.sfSort === 'price-asc' ? ' selected' : '') + '>Prix (croissant)</option>';
    h += '<option value="price-desc"' + (this.sfSort === 'price-desc' ? ' selected' : '') + '>Prix (d\u00e9croissant)</option>';
    h += '<option value="title-asc"' + (this.sfSort === 'title-asc' ? ' selected' : '') + '>Nom (A-Z)</option>';
    h += '</select></div></div>';

    // Grid
    if (filtered.length === 0) {
      h += '<div class="rb-empty">Aucune monture ne correspond \u00e0 vos filtres. Essayez d\u2019ajuster votre s\u00e9lection.</div>';
    } else {
      h += '<div class="rb-grid">';
      filtered.forEach(function (p) {
        // Find best variant matching active metal AND shape filters
        var displayVariant = p.variants[0];
        if (self.sfMetal || self.sfShape) {
          var bestVariant = p.variants.find(function (v) {
            var metalMatch = !self.sfMetal || v.option1 === self.sfMetal;
            var shapeMatch = !self.sfShape || v.option2 === self.sfShape;
            return metalMatch && shapeMatch;
          });
          // Fallback: try metal only, then shape only
          if (!bestVariant && self.sfMetal) {
            bestVariant = p.variants.find(function (v) { return v.option1 === self.sfMetal; });
          }
          if (!bestVariant && self.sfShape) {
            bestVariant = p.variants.find(function (v) { return v.option2 === self.sfShape; });
          }
          if (bestVariant) displayVariant = bestVariant;
        }

        var price = displayVariant ? displayVariant.price : '0';

        // Use variant featured image if metal or shape filter is active
        var imgSrc, imgHover;
        if ((self.sfMetal || self.sfShape) && displayVariant && displayVariant.featured_image && displayVariant.featured_image.src) {
          imgSrc = imgSize(displayVariant.featured_image.src, 400);
          imgHover = '';
        } else {
          imgSrc = p.images[1] ? imgSize(p.images[1].src, 400) : (p.images[0] ? imgSize(p.images[0].src, 400) : '');
          imgHover = p.images[0] ? imgSize(p.images[0].src, 400) : '';
        }

        var metals = uniqueMetalTypes(p.variants);

        h += '<div class="rb-card" data-action="view-setting" data-handle="' + esc(p.handle) + '">';
        h += '<div class="rb-card-image">';
        if (imgSrc) {
          h += '<img class="rb-card-img-default" src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" loading="lazy">';
          if (imgHover && imgHover !== imgSrc) {
            h += '<img class="rb-card-img-hover" src="' + esc(imgHover) + '" alt="' + esc(p.title) + '" loading="lazy">';
          }
        }
        h += '</div>';
        h += '<div class="rb-card-title">' + esc(p.title) + '</div>';
        h += '<div class="rb-card-swatches">';
        metals.forEach(function (m) {
          var activeSwatch = self.sfMetal === m ? ' is-active-swatch' : '';
          h += '<span class="rb-card-swatch' + activeSwatch + '" style="background:' + metalColor(m) + '" title="' + esc(m) + '"></span>';
        });
        h += '</div>';
        h += '<div class="rb-card-price">' + fmt(price) + '</div>';
        h += '</div>';
      });
      h += '</div>';
    }

    return h;
  };

  RingBuilder.prototype.getFilteredSettings = function () {
    var self = this;
    var out = this.settings.slice();

    if (this.sfStyle) {
      out = out.filter(function (p) {
        return detectStyle(p.title) === self.sfStyle;
      });
    }

    if (this.sfShape) {
      out = out.filter(function (p) {
        return p.variants.some(function (v) {
          return v.option2 && v.option2.toLowerCase() === self.sfShape.toLowerCase();
        });
      });
    }

    if (this.sfMetal) {
      out = out.filter(function (p) {
        return p.variants.some(function (v) {
          return v.option1 && v.option1.toLowerCase() === self.sfMetal.toLowerCase();
        });
      });
    }

    if (this.sfSort === 'price-asc') {
      out.sort(function (a, b) { return parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price); });
    } else if (this.sfSort === 'price-desc') {
      out.sort(function (a, b) { return parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price); });
    } else if (this.sfSort === 'title-asc') {
      out.sort(function (a, b) { return a.title.localeCompare(b.title); });
    }

    return out;
  };

  /* ---- Setting Detail ---- */
  RingBuilder.prototype.renderSettingDetail = function () {
    var p = this.settingDetail;
    if (!p) return '';

    var metals = uniqueMetalTypes(p.variants);
    var shapes = [];
    p.variants.forEach(function (v) {
      if (v.option2 && shapes.indexOf(v.option2) === -1) shapes.push(v.option2);
    });

    var selMetal = this.selectedMetal || metals[0];
    var selShape = this.selectedShape || shapes[0];

    // Find variant
    var variant = null;
    p.variants.forEach(function (v) {
      if (v.option1 === selMetal && v.option2 === selShape) variant = v;
    });
    if (!variant) variant = p.variants[0];

    // Find variant image
    var mainImg = '';
    if (variant && variant.featured_image && variant.featured_image.src) {
      mainImg = imgSize(variant.featured_image.src, 600);
    } else if (p.images[0]) {
      mainImg = imgSize(p.images[0].src, 600);
    }

    var self = this;
    var h = '';
    h += '<button class="rb-detail-back" data-action="back-browse">&larr; Retour</button>';
    h += '<div class="rb-detail">';

    // Left: images
    h += '<div class="rb-detail-left">';
    h += '<div class="rb-detail-image"><img src="' + esc(mainImg) + '" alt="' + esc(p.title) + '"></div>';
    if (p.images.length > 1) {
      h += '<div class="rb-detail-thumbs">';
      p.images.slice(0, 8).forEach(function (img, i) {
        h += '<div class="rb-detail-thumb' + (i === 0 ? ' is-active' : '') + '" data-action="thumb" data-src="' + esc(imgSize(img.src, 600)) + '">';
        h += '<img src="' + esc(imgSize(img.src, 120)) + '" alt="" loading="lazy"></div>';
      });
      h += '</div>';
    }
    h += '</div>';

    // Right: info
    h += '<div class="rb-detail-right">';
    h += '<div class="rb-detail-title">' + esc(p.title) + '</div>';

    // Shape selector
    h += '<div class="rb-detail-option-group">';
    h += '<div class="rb-detail-option-label">Forme</div>';
    h += '<div class="rb-detail-chips">';
    shapes.forEach(function (s) {
      var active = selShape === s ? ' is-active' : '';
      h += '<div class="rb-filter-chip' + active + '" data-action="det-shape" data-val="' + esc(s) + '">';
      h += (SHAPE_SVGS[s] || '') + '<span>' + esc(s) + '</span></div>';
    });
    h += '</div></div>';

    // Metal selector
    h += '<div class="rb-detail-option-group">';
    h += '<div class="rb-detail-option-label">M\u00e9tal</div>';
    h += '<div class="rb-detail-chips">';
    metals.forEach(function (m) {
      var active = selMetal === m ? ' is-active' : '';
      h += '<div class="rb-filter-chip' + active + '" data-action="det-metal" data-val="' + esc(m) + '">';
      h += '<span class="rb-swatch" style="background:' + metalColor(m) + '"></span>';
      h += '<span>' + esc(m) + '</span></div>';
    });
    h += '</div></div>';

    // Price
    h += '<div class="rb-detail-option-group">';
    h += '<div class="rb-detail-price-label">Prix</div>';
    h += '<div class="rb-detail-price-sub">Prix de la monture seulement</div>';
    h += '<div class="rb-detail-price">' + fmt(variant.price) + '</div>';
    h += '</div>';

    // Select button
    h += '<button class="rb-btn-primary" data-action="select-setting" data-variant-id="' + variant.id + '" data-metal="' + esc(selMetal) + '" data-shape="' + esc(selShape) + '">S\u00e9lectionner la monture</button>';

    // Description
    if (p.body_html) {
      h += '<div class="rb-accordion">';
      h += '<div class="rb-accordion-header" data-action="toggle-desc">Description <span>&#9660;</span></div>';
      h += '<div class="rb-accordion-body is-hidden">' + p.body_html + '</div>';
      h += '</div>';
    }

    h += '</div>'; // right
    h += '</div>'; // detail

    return h;
  };

  /* ---- Step 2: Diamonds ---- */
  RingBuilder.prototype.renderStep2 = function () {
    var self = this;
    var filtered = this.getFilteredDiamonds();

    var h = '';

    // Back button
    h += '<button class="rb-back-btn" data-action="back-step"><span class="rb-back-arrow">&larr;</span> Retour aux montures</button>';

    // Type tabs
    h += '<div class="rb-type-tabs">';
    var typeLabels = { 'Natural': 'Naturel', 'Lab Grown': 'Laboratoire' };
    ['Natural', 'Lab Grown'].forEach(function (t) {
      var active = self.dfType === t ? ' is-active' : '';
      h += '<button class="rb-type-tab' + active + '" data-action="df-type" data-val="' + t + '">' + (typeLabels[t] || t) + '</button>';
    });
    h += '</div>';

    // Two-column: filters left + hand model right
    h += '<div class="rb-step2-top">';

    // Filters
    h += '<div class="rb-filters">';
    h += '<button class="rb-filter-toggle" data-action="toggle-filters">' + (this.filtersVisible ? 'Hide' : 'Show') + ' filtres</button>';

    if (this.filtersVisible) {
      // Shape filter — show all shapes, highlight the setting's default shape
      h += '<div class="rb-filter-row">';
      h += '<div class="rb-filter-group"><label>Forme</label><div class="rb-filter-chips">';

      // Check which shapes this setting supports (from variant option2)
      var settingShapes = {};
      if (self.selectedSetting) {
        self.selectedSetting.variants.forEach(function (v) {
          if (v.option2) settingShapes[v.option2] = true;
        });
      }

      SHAPES.forEach(function (s) {
        var active = self.dfShape === s ? ' is-active' : '';
        var supported = Object.keys(settingShapes).length === 0 || settingShapes[s];
        var cls = 'rb-filter-chip' + active + (supported ? '' : ' rb-chip-unavailable');
        h += '<div class="' + cls + '" data-action="df-shape" data-val="' + s + '">';
        h += (SHAPE_SVGS[s] || '') + '<span>' + s + '</span></div>';
      });
      h += '</div></div></div>';

      // Clarity chips
      h += '<div class="rb-filter-row">';
      h += '<div class="rb-filter-group"><label>Clart\u00e9</label><div class="rb-filter-chips">';
      CLARITIES.forEach(function (c) {
        var active = self.dfClarity === c ? ' is-active' : '';
        h += '<div class="rb-filter-chip rb-filter-chip-sm' + active + '" data-action="df-clarity-chip" data-val="' + c + '">' + c + '</div>';
      });
      h += '</div></div>';

      // Color chips
      h += '<div class="rb-filter-group"><label>Couleur</label><div class="rb-filter-chips">';
      COLORS.forEach(function (c) {
        var active = self.dfColor === c ? ' is-active' : '';
        h += '<div class="rb-filter-chip rb-filter-chip-sm' + active + '" data-action="df-color-chip" data-val="' + c + '">' + c + '</div>';
      });
      h += '</div></div>';
      h += '</div>';

      // Carat (ct) — min/max inputs + chip shortcuts
      h += '<div class="rb-filter-row rb-filter-row-carat">';
      h += '<div class="rb-filter-group rb-filter-group-full"><label>Carat (ct)</label>';

      // Min / Max inputs
      h += '<div class="rb-carat-controls">';
      h += '<div class="rb-carat-inputs">';
      h += '<div class="rb-carat-input-wrap"><span class="rb-carat-label">Min</span>';
      h += '<input type="number" class="rb-carat-input" data-action="df-carat-min-input" value="' + esc(self.dfCaratMin) + '" min="0.5" max="10" step="0.1"><span class="rb-carat-unit">ct</span></div>';
      h += '<div class="rb-carat-input-wrap"><span class="rb-carat-label">Max</span>';
      h += '<input type="number" class="rb-carat-input" data-action="df-carat-max-input" value="' + esc(self.dfCaratMax) + '" min="0.5" max="10" step="0.1"><span class="rb-carat-unit">ct</span></div>';
      h += '</div>';

      // Quick-select carat chips
      h += '<div class="rb-filter-chips rb-carat-chips">';
      CARATS.forEach(function (c) {
        var isActive = parseFloat(self.dfCaratMin) === parseFloat(c) && parseFloat(self.dfCaratMax) === parseFloat(c);
        var active = isActive ? ' is-active' : '';
        h += '<div class="rb-filter-chip rb-filter-chip-sm' + active + '" data-action="df-carat-chip" data-val="' + c + '">' + c + 'ct</div>';
      });
      h += '</div>';

      // Clear button
      var isDefaultRange = self.dfCaratMin === '0.5' && self.dfCaratMax === '4';
      if (!isDefaultRange) {
        h += '<div class="rb-carat-clear" data-action="df-carat-clear">Effacer &times;</div>';
      }

      h += '</div>'; // carat-controls
      h += '</div></div>'; // filter-group + filter-row
    }
    h += '</div>'; // filters

    // Hand model diamond size viewer
    var viewerShape = this.dfShape || this.selectedShape || 'Round';
    var viewerCarat = parseFloat(this.dfCaratMin) === parseFloat(this.dfCaratMax)
      ? parseFloat(this.dfCaratMin) : 2; // default to 2ct preview
    h += this.renderHandModel(viewerShape, viewerCarat);

    h += '</div>'; // step2-top (two-column wrapper)

    // Results bar
    h += '<div class="rb-results-bar">';
    h += '<div class="rb-results-count">R\u00e9sultats - <strong>' + filtered.length + '</strong> Diamants</div>';
    h += '<div style="display:flex;gap:12px;align-items:center;">';
    h += '<div class="rb-view-toggle">';
    h += '<button class="rb-view-btn' + (this.diamondView === 'list' ? ' is-active' : '') + '" data-action="view-mode" data-val="list">LISTE</button>';
    h += '<button class="rb-view-btn' + (this.diamondView === 'grid' ? ' is-active' : '') + '" data-action="view-mode" data-val="grid">GRILLE</button>';
    h += '</div>';
    h += '<div class="rb-sort-wrap"><label>Trier :</label>';
    h += '<select data-action="df-sort">';
    h += '<option value="price-asc"' + (this.dfSort === 'price-asc' ? ' selected' : '') + '>Prix (croissant)</option>';
    h += '<option value="price-desc"' + (this.dfSort === 'price-desc' ? ' selected' : '') + '>Prix (d\u00e9croissant)</option>';
    h += '<option value="carat-asc"' + (this.dfSort === 'carat-asc' ? ' selected' : '') + '>Carat (croissant)</option>';
    h += '<option value="carat-desc"' + (this.dfSort === 'carat-desc' ? ' selected' : '') + '>Carat (d\u00e9croissant)</option>';
    h += '</select></div>';
    h += '</div></div>';

    // Content
    if (filtered.length === 0) {
      h += '<div class="rb-empty">Aucun diamant ne correspond \u00e0 vos filtres. Essayez d\u2019ajuster votre s\u00e9lection.</div>';
    } else if (this.diamondView === 'grid') {
      h += this.renderDiamondGrid(filtered);
    } else {
      h += this.renderDiamondTable(filtered);
    }

    return h;
  };

  /* ---- Hand Model Diamond Size Viewer ---- */
  RingBuilder.prototype.renderHandModel = function (shape, carat) {
    var h = '<div class="rb-hand-viewer">';
    h += '<div class="rb-hand-title">Aper\u00e7u sur main</div>';
    h += '<div class="rb-hand-container" id="rb-hand-container">';
    h += '<img src="' + esc(HAND_IMG) + '" alt="Hand model" class="rb-hand-img" draggable="false">';

    // Diamond overlay — positioned on ring finger
    var shapeSvg = DIAMOND_SHAPE_SVGS[shape] || DIAMOND_SHAPE_SVGS['Round'];
    h += '<div class="rb-hand-diamond" id="rb-hand-diamond" style="top:' + DIAMOND_POS.top + '%;left:' + DIAMOND_POS.left + '%;">';
    h += shapeSvg;
    h += '</div>';

    // Carat label
    h += '<div class="rb-hand-carat-label">Montr\u00e9 avec diamant de <strong>' + carat + ' carat</strong></div>';
    h += '</div>'; // hand-container

    // Vertical slider
    h += '<div class="rb-hand-slider">';
    h += '<div class="rb-hand-slider-label rb-hand-slider-top">4ct</div>';
    h += '<input type="range" class="rb-hand-slider-input" data-action="hand-carat-slider" ';
    h += 'min="0.5" max="4" step="0.5" value="' + carat + '" orient="vertical">';
    h += '<div class="rb-hand-slider-label rb-hand-slider-bottom">0.5ct</div>';
    h += '</div>';

    h += '</div>'; // hand-viewer
    return h;
  };

  // Update diamond size overlay (called after render via JS)
  RingBuilder.prototype.updateHandDiamond = function (carat) {
    var container = document.getElementById('rb-hand-container');
    var diamond = document.getElementById('rb-hand-diamond');
    if (!container || !diamond) return;

    var shape = this.dfShape || this.selectedShape || 'Round';
    var containerWidth = container.offsetWidth;
    var size = getDiamondSizePx(shape, carat, containerWidth);

    diamond.style.width = size.w + 'px';
    diamond.style.height = size.h + 'px';
    diamond.style.marginLeft = (-size.w / 2) + 'px';
    diamond.style.marginTop = (-size.h / 2) + 'px';

    // Update shape SVG
    var shapeSvg = DIAMOND_SHAPE_SVGS[shape] || DIAMOND_SHAPE_SVGS['Round'];
    diamond.innerHTML = shapeSvg;

    // Update label
    var label = container.querySelector('.rb-hand-carat-label');
    if (label) label.innerHTML = 'Montr\u00e9 avec diamant de <strong>' + carat + ' carat</strong>';
  };

  RingBuilder.prototype.renderDiamondGrid = function (diamonds) {
    var h = '<div class="rb-grid">';
    diamonds.forEach(function (p) {
      var price = p.variants[0] ? p.variants[0].price : '0';
      var imgSrc = p.images[0] ? imgSize(p.images[0].src, 400) : '';
      var shape = tag(p.tags, 'shape') || '';
      var carat = tag(p.tags, 'carat') || '';
      var color = tag(p.tags, 'color') || '';
      var clarity = tag(p.tags, 'clarity') || '';
      var cut = tag(p.tags, 'cut') || '';
      var cert = tag(p.tags, 'cert') || '';
      var videoSrc = shape ? diamondVideoUrl(shape) : '';

      h += '<div class="rb-card">';
      h += '<div class="rb-card-image rb-diamond-hover">';
      if (imgSrc) h += '<img class="rb-card-img-default" src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" loading="lazy">';
      if (videoSrc) h += '<video class="rb-card-vid-hover" src="' + esc(videoSrc) + '" muted loop playsinline preload="none"></video>';
      h += '</div>';
      h += '<div class="rb-card-title">' + esc(p.title) + '</div>';
      h += '<div class="rb-card-specs">';
      if (color) h += 'Couleur : <strong>' + esc(color) + '</strong> ';
      if (clarity) h += 'Clart\u00e9 : <strong>' + esc(clarity) + '</strong> ';
      if (cut) h += 'Taille : <strong>' + esc(cut) + '</strong>';
      h += '</div>';
      h += '<div class="rb-card-price">' + fmt(price);
      if (cert) h += ' <span class="rb-card-cert">' + esc(cert) + ' Certifi\u00e9</span>';
      h += '</div>';
      var dVarAttr = p._variant ? ' data-variant-id="' + p._variant.id + '"' : '';
      h += '<button class="rb-card-btn" data-action="select-diamond" data-handle="' + esc(p.handle) + '"' + dVarAttr + '>S\u00e9lectionner le diamant</button>';
      h += '</div>';
    });
    h += '</div>';
    return h;
  };

  RingBuilder.prototype.renderDiamondTable = function (diamonds) {
    var h = '<table class="rb-table"><thead><tr>';
    h += '<th>Forme</th><th>Carat</th><th>Couleur</th><th>Clart\u00e9</th><th>Taille</th><th>Cert</th><th>Prix</th><th></th>';
    h += '</tr></thead><tbody>';

    diamonds.forEach(function (p) {
      var price = p.variants[0] ? p.variants[0].price : '0';
      var shape = tag(p.tags, 'shape') || '-';
      var carat = tag(p.tags, 'carat') || '-';
      var color = tag(p.tags, 'color') || '-';
      var clarity = tag(p.tags, 'clarity') || '-';
      var cut = tag(p.tags, 'cut') || '-';
      var cert = tag(p.tags, 'cert') || '-';

      h += '<tr>';
      h += '<td>' + esc(shape) + '</td>';
      h += '<td>' + esc(carat) + ' ct</td>';
      h += '<td>' + esc(color) + '</td>';
      h += '<td>' + esc(clarity) + '</td>';
      h += '<td>' + esc(cut) + '</td>';
      h += '<td>' + esc(cert) + '</td>';
      h += '<td class="rb-price-cell">' + fmt(price) + '</td>';
      var tVarAttr = p._variant ? ' data-variant-id="' + p._variant.id + '"' : '';
      h += '<td><button class="rb-card-btn" data-action="select-diamond" data-handle="' + esc(p.handle) + '"' + tVarAttr + '>Choisir</button></td>';
      h += '</tr>';
    });

    h += '</tbody></table>';
    return h;
  };

  RingBuilder.prototype.getFilteredDiamonds = function () {
    var self = this;
    var out = this.diamonds.slice();

    // Type filter
    out = out.filter(function (p) {
      var t = tag(p.tags, 'type');
      return t && t.toLowerCase() === self.dfType.toLowerCase();
    });

    // Shape filter (from setting or manual)
    var shapeFilter = this.dfShape || this.selectedShape;
    if (shapeFilter) {
      out = out.filter(function (p) {
        var s = tag(p.tags, 'shape');
        return s && s.toLowerCase() === shapeFilter.toLowerCase();
      });
    }

    // Carat range
    var minCt = parseFloat(this.dfCaratMin) || 0;
    var maxCt = parseFloat(this.dfCaratMax) || 99;
    out = out.filter(function (p) {
      var c = parseFloat(tag(p.tags, 'carat'));
      return !isNaN(c) && c >= minCt && c <= maxCt;
    });

    // Color
    if (this.dfColor) {
      out = out.filter(function (p) {
        var c = tag(p.tags, 'color');
        return c && c.toUpperCase() === self.dfColor.toUpperCase();
      });
    }

    // Clarity
    if (this.dfClarity) {
      out = out.filter(function (p) {
        var c = tag(p.tags, 'clarity');
        return c && c.toUpperCase() === self.dfClarity.toUpperCase();
      });
    }

    // Sort
    if (this.dfSort === 'price-asc') {
      out.sort(function (a, b) { return parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price); });
    } else if (this.dfSort === 'price-desc') {
      out.sort(function (a, b) { return parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price); });
    } else if (this.dfSort === 'carat-asc') {
      out.sort(function (a, b) { return parseFloat(tag(a.tags,'carat')||0) - parseFloat(tag(b.tags,'carat')||0); });
    } else if (this.dfSort === 'carat-desc') {
      out.sort(function (a, b) { return parseFloat(tag(b.tags,'carat')||0) - parseFloat(tag(a.tags,'carat')||0); });
    }

    return out;
  };

  /* ---- Step 3: Summary ---- */
  RingBuilder.prototype.renderStep3 = function () {
    var setting = this.selectedSetting;
    var diamond = this.selectedDiamond;
    if (!setting || !diamond) return '<div class="rb-empty">Veuillez s\u00e9lectionner une monture et un diamant.</div>';

    var settingPrice = this.selectedVariant ? parseFloat(this.selectedVariant.price) : 0;
    var diamondVariant = this.selectedDiamondVariant || diamond.variants[0];
    var diamondPrice = parseFloat(diamondVariant.price);
    var total = settingPrice + diamondPrice;

    var settingImg = setting.images[0] ? imgSize(setting.images[0].src, 600) : '';
    var diamondImg = diamond.images[0] ? imgSize(diamond.images[0].src, 600) : '';

    // Nivoda video/images for setting
    var model = nivodaModel(setting);
    var videoUrl = model ? nivodaVideoUrl(model, this.selectedShape, this.selectedMetal) : '';
    var cdnImgs = model ? nivodaImageUrls(model, this.selectedShape, this.selectedMetal) : null;

    // Diamond video
    var dShapeForVideo = tag(diamond.tags, 'shape') || '';
    var diamondVideoSrc = dShapeForVideo ? diamondVideoUrl(dShapeForVideo) : '';

    var h = '';
    // Back button
    h += '<button class="rb-back-btn" data-action="back-step"><span class="rb-back-arrow">&larr;</span> Retour aux diamants</button>';
    h += '<div class="rb-summary">';

    // Left: video + thumbnails
    h += '<div class="rb-summary-left">';
    if (videoUrl) {
      h += '<div class="rb-summary-media" id="rb-media-main">';
      h += '<video src="' + esc(videoUrl) + '" autoplay loop muted playsinline preload="auto" class="rb-summary-video"></video>';
      h += '</div>';
      // Thumbnail strip
      h += '<div class="rb-summary-thumbs">';
      h += '<div class="rb-summary-thumb is-active" data-action="media-thumb" data-type="video" data-src="' + esc(videoUrl) + '">';
      h += '<video src="' + esc(videoUrl) + '" muted class="rb-thumb-video"></video>';
      h += '<span class="rb-thumb-play">&#9654;</span></div>';
      if (cdnImgs) {
        h += '<div class="rb-summary-thumb" data-action="media-thumb" data-type="image" data-src="' + esc(cdnImgs.side) + '">';
        h += '<img src="' + esc(cdnImgs.side) + '" alt="Side" loading="lazy"></div>';
        h += '<div class="rb-summary-thumb" data-action="media-thumb" data-type="image" data-src="' + esc(cdnImgs.front) + '">';
        h += '<img src="' + esc(cdnImgs.front) + '" alt="Front" loading="lazy"></div>';
        h += '<div class="rb-summary-thumb" data-action="media-thumb" data-type="image" data-src="' + esc(cdnImgs.threeD) + '">';
        h += '<img src="' + esc(cdnImgs.threeD) + '" alt="3D" loading="lazy"></div>';
      }
      // Also show Shopify product images as additional thumbs
      setting.images.slice(0, 3).forEach(function (img) {
        h += '<div class="rb-summary-thumb" data-action="media-thumb" data-type="image" data-src="' + esc(imgSize(img.src, 600)) + '">';
        h += '<img src="' + esc(imgSize(img.src, 120)) + '" alt="" loading="lazy"></div>';
      });
      // Diamond video thumbnail
      if (diamondVideoSrc) {
        h += '<div class="rb-summary-thumb" data-action="media-thumb" data-type="video" data-src="' + esc(diamondVideoSrc) + '">';
        h += '<video src="' + esc(diamondVideoSrc) + '" muted class="rb-thumb-video"></video>';
        h += '<span class="rb-thumb-play">&#9654;</span><span class="rb-thumb-label">Diamant</span></div>';
      }
      // Diamond image thumbnail
      if (diamondImg) {
        h += '<div class="rb-summary-thumb" data-action="media-thumb" data-type="image" data-src="' + esc(diamondImg) + '">';
        h += '<img src="' + esc(imgSize(diamond.images[0].src, 120)) + '" alt="Diamond" loading="lazy"></div>';
      }
      h += '</div>';
    } else {
      h += '<div class="rb-summary-media"><img src="' + esc(settingImg) + '" alt="' + esc(setting.title) + '"></div>';
    }
    h += '</div>';

    // Right: summary
    h += '<div class="rb-summary-right">';
    h += '<div class="rb-summary-title">R\u00e9sum\u00e9 de votre bague</div>';

    // Setting item
    h += '<div class="rb-summary-item">';
    h += '<div class="rb-summary-item-icon">&#128141;</div>';
    h += '<div class="rb-summary-item-info">';
    h += '<div class="rb-summary-item-name">' + esc(setting.title) + '</div>';
    h += '<div class="rb-summary-item-meta">' + esc(this.selectedMetal + ' / ' + this.selectedShape) + '</div>';
    h += '<div class="rb-summary-item-actions"><a data-remove="1">Retirer</a></div>';
    h += '</div>';
    h += '<div class="rb-summary-item-price">' + fmt(settingPrice) + '</div>';
    h += '</div>';

    // Diamond item
    var dShape = tag(diamond.tags, 'shape') || '';
    var dCarat = tag(diamond.tags, 'carat') || '';
    var dColor = tag(diamond.tags, 'color') || '';
    var dClarity = tag(diamond.tags, 'clarity') || '';
    var dCut = tag(diamond.tags, 'cut') || '';

    h += '<div class="rb-summary-item">';
    h += '<div class="rb-summary-item-icon">&#128142;</div>';
    h += '<div class="rb-summary-item-info">';
    h += '<div class="rb-summary-item-name">' + esc(diamond.title) + '</div>';
    h += '<div class="rb-summary-item-meta">Couleur ' + esc(dColor) + ', Clart\u00e9 ' + esc(dClarity);
    if (dCut) h += ', Taille ' + esc(dCut);
    h += '</div>';
    h += '<div class="rb-summary-item-actions"><a data-remove="2">Retirer</a></div>';
    h += '</div>';
    h += '<div class="rb-summary-item-price">' + fmt(diamondPrice) + '</div>';
    h += '</div>';

    // Ring size
    h += '<div class="rb-ringsize">';
    h += '<div class="rb-ringsize-label">Taille de bague</div>';
    h += '<input type="text" class="rb-ringsize-input" placeholder="ex. 7" value="' + esc(this.ringSize) + '" data-action="ring-size">';
    h += '</div>';

    // Total
    h += '<div class="rb-total">';
    h += '<div class="rb-total-label">Total</div>';
    h += '<div class="rb-total-price">' + fmt(total) + '</div>';
    h += '</div>';

    // Add to cart
    h += '<button class="rb-btn-cart" data-action="add-to-cart">Ajouter au panier</button>';

    // Save quote / Send a hint
    h += '<div class="rb-quote-actions">';
    h += '<button class="rb-btn-quote" data-action="save-quote">';
    h += '<span class="rb-btn-icon">&#128230;</span> Sauvegarder ma s\u00e9lection</button>';
    h += '<button class="rb-btn-hint" data-action="send-hint">';
    h += '<span class="rb-btn-icon">&#128140;</span> Envoyer un indice</button>';
    h += '</div>';

    h += '</div>'; // right
    h += '</div>'; // summary

    return h;
  };

  /* ---- Event Binding ---- */
  RingBuilder.prototype.bindEvents = function () {
    var self = this;
    var el = this.el;

    // Diamond card video hover
    el.addEventListener('mouseenter', function (e) {
      var card = e.target.closest('.rb-diamond-hover');
      if (card) {
        var vid = card.querySelector('.rb-card-vid-hover');
        if (vid) {
          vid.currentTime = 0;
          vid.play().catch(function () {});
        }
      }
    }, true);

    el.addEventListener('mouseleave', function (e) {
      var card = e.target.closest('.rb-diamond-hover');
      if (card) {
        var vid = card.querySelector('.rb-card-vid-hover');
        if (vid) {
          vid.pause();
          vid.currentTime = 0;
        }
      }
    }, true);

    // Delegated click handler
    el.addEventListener('click', function (e) {
      var target = e.target.closest('[data-action]');
      if (!target) {
        // Check for step click
        var stepEl = e.target.closest('[data-step]');
        if (stepEl) {
          var sn = parseInt(stepEl.dataset.step);
          if (sn === 1 || (sn === 2 && self.selectedSetting) || (sn === 3 && self.selectedSetting && self.selectedDiamond)) {
            self.step = sn;
            self.settingDetail = null;
            self.render();
          }
        }
        // Check remove
        var removeEl = e.target.closest('[data-remove]');
        if (removeEl) {
          e.stopPropagation();
          var rn = parseInt(removeEl.dataset.remove);
          if (rn === 1) {
            self.selectedSetting = null;
            self.selectedVariant = null;
            self.selectedMetal = null;
            self.selectedShape = null;
            self.step = 1;
          } else if (rn === 2) {
            self.selectedDiamond = null;
            self.step = 2;
          }
          self.render();
        }
        return;
      }

      var action = target.dataset.action;
      var val = target.dataset.val;

      switch (action) {
        case 'toggle-filters':
          self.filtersVisible = !self.filtersVisible;
          self.render();
          break;

        case 'back-step':
          if (self.step > 1) {
            self.step = self.step - 1;
            if (self.step === 1) self.settingDetail = null;
            self.render();
            self.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          break;

        case 'sf-shape':
          self.sfShape = self.sfShape === val ? null : val;
          self.render();
          break;

        case 'sf-metal':
          self.sfMetal = self.sfMetal === val ? null : val;
          self.render();
          break;

        case 'sf-style':
          self.sfStyle = self.sfStyle === val ? null : val;
          self.render();
          break;

        case 'sf-toggle-styles':
          self.sfShowAllStyles = !self.sfShowAllStyles;
          self.render();
          break;

        case 'sf-toggle-metals':
          self.sfShowAllMetals = !self.sfShowAllMetals;
          self.render();
          break;

        case 'sf-toggle-shapes':
          self.sfShowAllShapes = !self.sfShowAllShapes;
          self.render();
          break;

        case 'view-setting':
          var handle = target.dataset.handle;
          var product = self.settings.find(function (p) { return p.handle === handle; });
          if (product) {
            self.settingDetail = product;
            // Pre-select metal/shape from Step 1 filters if set
            self.selectedMetal = self.sfMetal || null;
            self.selectedShape = self.sfShape || null;
            self.render();
            self.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          break;

        case 'back-browse':
          self.settingDetail = null;
          self.render();
          break;

        case 'det-shape':
          self.selectedShape = val;
          self.render();
          break;

        case 'det-metal':
          self.selectedMetal = val;
          self.render();
          break;

        case 'select-setting':
          var variantId = parseInt(target.dataset.variantId);
          self.selectedSetting = self.settingDetail;
          self.selectedMetal = target.dataset.metal;
          self.selectedShape = target.dataset.shape;
          self.selectedVariant = self.settingDetail.variants.find(function (v) { return v.id === variantId; });
          self.settingDetail = null;
          self.dfShape = self.selectedShape; // pre-filter diamonds to matching shape
          self.step = 2;
          self.render();
          self.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          break;

        case 'thumb':
          var src = target.dataset.src;
          var mainImg = el.querySelector('.rb-detail-image img');
          if (mainImg && src) {
            mainImg.src = src;
            el.querySelectorAll('.rb-detail-thumb').forEach(function (t) { t.classList.remove('is-active'); });
            target.classList.add('is-active');
          }
          break;

        case 'toggle-desc':
          var body = target.nextElementSibling;
          if (body) body.classList.toggle('is-hidden');
          break;

        case 'df-type':
          self.dfType = val;
          self.render();
          break;

        case 'df-shape':
          self.dfShape = self.dfShape === val ? null : val;
          // Update selected shape and variant to match new shape
          if (self.dfShape && self.selectedSetting && self.selectedMetal) {
            var newVariant = self.selectedSetting.variants.find(function (v) {
              return v.option1 === self.selectedMetal && v.option2 === self.dfShape;
            });
            if (newVariant) {
              self.selectedShape = self.dfShape;
              self.selectedVariant = newVariant;
            }
          } else if (self.dfShape) {
            self.selectedShape = self.dfShape;
          }
          self.render();
          break;

        case 'df-carat-chip':
          // Toggle: if clicking same exact carat, reset to full range
          if (parseFloat(self.dfCaratMin) === parseFloat(val) && parseFloat(self.dfCaratMax) === parseFloat(val)) {
            self.dfCaratMin = '0.5';
            self.dfCaratMax = '4';
          } else {
            self.dfCaratMin = val;
            self.dfCaratMax = val;
          }
          self.render();
          break;

        case 'df-carat-clear':
          self.dfCaratMin = '0.5';
          self.dfCaratMax = '4';
          self.render();
          break;

        case 'df-clarity-chip':
          self.dfClarity = self.dfClarity === val ? null : val;
          self.render();
          break;

        case 'df-color-chip':
          self.dfColor = self.dfColor === val ? null : val;
          self.render();
          break;

        case 'view-mode':
          self.diamondView = val;
          self.render();
          break;

        case 'select-diamond':
          var dHandle = target.dataset.handle;
          var dVarId = target.dataset.variantId ? parseInt(target.dataset.variantId) : null;
          var dProduct;
          if (dVarId) {
            // Find the exact variant-based entry
            dProduct = self.diamonds.find(function (p) { return p._variant && p._variant.id === dVarId; });
          }
          if (!dProduct) {
            dProduct = self.diamonds.find(function (p) { return p.handle === dHandle; });
          }
          if (dProduct) {
            self.selectedDiamond = dProduct;
            self.selectedDiamondVariant = dProduct._variant || dProduct.variants[0];
            self.step = 3;
            self.render();
            self.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          break;

        case 'add-to-cart':
          self.addToCart();
          break;

        case 'save-quote':
        case 'send-hint':
          // Build quote data for workflow trigger
          var qDiamondVar = self.selectedDiamondVariant || (self.selectedDiamond ? self.selectedDiamond.variants[0] : null);
          var quoteData = {
            action: action,
            setting: self.selectedSetting ? self.selectedSetting.title : '',
            settingPrice: self.selectedVariant ? self.selectedVariant.price : '',
            metal: self.selectedMetal || '',
            shape: self.selectedShape || '',
            diamond: self.selectedDiamond ? self.selectedDiamond.title : '',
            diamondPrice: qDiamondVar ? qDiamondVar.price : '',
            diamondClarity: qDiamondVar ? qDiamondVar.option2 : '',
            diamondColor: qDiamondVar ? qDiamondVar.option3 : '',
            ringSize: self.ringSize || '',
            total: self.selectedVariant && qDiamondVar
              ? (parseFloat(self.selectedVariant.price) + parseFloat(qDiamondVar.price)).toFixed(2)
              : ''
          };
          // Dispatch custom event for external workflow integration
          window.dispatchEvent(new CustomEvent('bjamil-ring-builder', { detail: quoteData }));
          // Placeholder: show confirmation
          var msg = action === 'save-quote'
            ? 'Votre sélection a été sauvegardée! Nous vous contacterons sous peu.'
            : 'Un indice a été envoyé! La personne chanceuse recevra un message.';
          var toast = document.createElement('div');
          toast.className = 'rb-toast';
          toast.textContent = msg;
          self.el.appendChild(toast);
          setTimeout(function () { toast.remove(); }, 4000);
          break;

        case 'media-thumb':
          var mediaType = target.dataset.type;
          var mediaSrc = target.dataset.src;
          var mainEl = document.getElementById('rb-media-main');
          if (mainEl && mediaSrc) {
            if (mediaType === 'video') {
              mainEl.innerHTML = '<video src="' + mediaSrc + '" autoplay loop muted playsinline preload="auto" class="rb-summary-video"></video>';
            } else {
              mainEl.innerHTML = '<img src="' + mediaSrc + '" alt="" class="rb-summary-video">';
            }
            // Update active thumb
            var allThumbs = self.el.querySelectorAll('.rb-summary-thumb');
            allThumbs.forEach(function (t) { t.classList.remove('is-active'); });
            target.closest('.rb-summary-thumb').classList.add('is-active');
          }
          break;
      }
    });

    // Delegated change handler for selects
    el.addEventListener('change', function (e) {
      var target = e.target;
      var action = target.dataset.action;
      if (!action) return;

      switch (action) {
        case 'sf-sort':
          self.sfSort = target.value;
          self.render();
          break;
        case 'df-carat-min':
        case 'df-carat-min-input':
          self.dfCaratMin = target.value;
          self.render();
          break;
        case 'df-carat-max':
        case 'df-carat-max-input':
          self.dfCaratMax = target.value;
          self.render();
          break;
        case 'df-sort':
          self.dfSort = target.value;
          self.render();
          break;
      }
    });

    // Ring size input + hand model slider
    el.addEventListener('input', function (e) {
      if (e.target.dataset.action === 'ring-size') {
        self.ringSize = e.target.value;
      }
      if (e.target.dataset.action === 'hand-carat-slider') {
        var ct = parseFloat(e.target.value);
        self.updateHandDiamond(ct);
      }
    });
  };

  /* ---- Ajouter au panier ---- */
  RingBuilder.prototype.addToCart = function () {
    if (!this.selectedVariant || !this.selectedDiamond) return;

    var ringSize = this.ringSize.trim();
    if (!ringSize) {
      alert('Veuillez entrer une taille de bague.');
      return;
    }

    var bundleId = 'ring-' + Date.now();
    var diamondVariant = this.selectedDiamondVariant || this.selectedDiamond.variants[0];

    var items = [
      {
        id: this.selectedVariant.id,
        quantity: 1,
        properties: {
          '_bundle_id': bundleId,
          'Taille de bague': ringSize,
          'Diamant associ\u00e9': this.selectedDiamond.title,
          'M\u00e9tal': this.selectedMetal,
          'Forme': this.selectedShape
        }
      },
      {
        id: diamondVariant.id,
        quantity: 1,
        properties: {
          '_bundle_id': bundleId,
          'Monture associ\u00e9e': this.selectedSetting.title
        }
      }
    ];

    var btn = this.el.querySelector('[data-action="add-to-cart"]');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Ajout en cours...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart error');
        return r.json();
      })
      .then(function () {
        // Open cart drawer or redirect
        if (btn) {
          btn.textContent = 'Ajout\u00e9 au panier !';
          btn.style.background = '#27ae60';
        }
        // Try to open cart drawer if theme supports it
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // Dispatch event for themes that listen
          document.dispatchEvent(new CustomEvent('cart:updated'));
          // Fallback: redirect to cart after brief delay
          setTimeout(function () {
            window.location.href = '/cart';
          }, 1000);
        }
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        alert('Erreur lors de l\u2019ajout au panier. Veuillez r\u00e9essayer.');
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Ajouter au panier';
        }
      });
  };

  /* ---- Initialize ---- */
  function initRingBuilder() {
    var els = document.querySelectorAll('[data-ring-builder]');
    els.forEach(function (el) {
      new RingBuilder(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRingBuilder);
  } else {
    initRingBuilder();
  }
})();

